import { SYNC_FORM_VALUE_CHANGED_BOOLEAN } from '.';

export default value => ({
  type: SYNC_FORM_VALUE_CHANGED_BOOLEAN,
  payload: value,
});
